import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getFeatureMetadata } from 'selectors/feature/featureMetadata'
import {
  getFastFeatureIsFastFeature,
  getFastFeatureIsToggling,
} from 'selectors/feature/fastFeature'
import {
  loadFastFeatureStatus,
  toggleFastFeatureStatus,
} from 'actions/feature/fastFeatures'
import FastFeatureControl from './FastFeatureControl'

const mapStateToProps = (state) => {
  const {
    id: featureId,
    partNumber,
    description,
    moduleName,
    minCompatibleVariant,
  } = getFeatureMetadata(state)

  // Read revision the same way as FeatureStatusContainer
  const revision = featureId
    ? state.getIn(
        ['feature', 'currentFeature', 'feature', featureId, 'revision'],
        '-'
      )
    : '-'

  return {
    featureId,
    featureNumber: partNumber,
    revision,
    featureDescription: description,
    minDiagVariant: minCompatibleVariant,
    ecu: moduleName,
    isFastFeature: getFastFeatureIsFastFeature(state),
    isToggling: getFastFeatureIsToggling(state),
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onLoad: loadFastFeatureStatus,
      onToggle: toggleFastFeatureStatus,
    },
    dispatch
  )

const FastFeatureControlContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(FastFeatureControl)

export default FastFeatureControlContainer
